import { capitalizeEveryWord } from '../../utils/capitalizeEveryWord'

const DEFAULT_PREFIXES = {
  Location: '',
  special_consideration: 'with',
  activity: 'with',
  insurance_accepted: '',
  accepted_insurance: 'Accepting',
  treatment_method: '',
  treatment_therapy: 'with',
  amenities: '',
  setting: '',
  price: '',
  what_we_treat: '',
  treatment_services: '',
  who_we_treat: '',
  'Location+special_consideration': 'with',
  'Location+special_considerations': 'with',
  'Location+activities': 'with',
  'Location+accepted_insurance': 'Accepting',
  'Location+insurance_accepted': '',
  'Location+treatment_methods': '',
  'Location+treatment_therapies': 'with',
  'Location+amenities': '',
  'Location+setting': '',
  'Location+price': '',
  'Location+what_we_treat': '',
  'Location+treatment_services': '',
  'Location+who_we_treat': ''
}

export const getDefaultTermHeader = (pageType, termTitle) => {
  const prefix = DEFAULT_PREFIXES[pageType]
  if (prefix === '') return capitalizeEveryWord(termTitle)
  return `${prefix} ${capitalizeEveryWord(termTitle)}`
}
